import useClubs from '@club/admin/hooks/useClubs';
import React, { useCallback } from 'react';
import PromocodeForm from '../components/PromocodeForm';

export default function usePromoForm() {
    const { options: clubs } = useClubs()

    return useCallback((props: Modules.Resource.Form<Resources.ClubPromo>) => {
        return <PromocodeForm {...props} clubs={clubs} />
    }, [clubs])
}